import { render } from "./Cockpit.vue?vue&type=template&id=4ddb1d9c&scoped=true"
import script from "./Cockpit.vue?vue&type=script&lang=js"
export * from "./Cockpit.vue?vue&type=script&lang=js"

import "./Cockpit.vue?vue&type=style&index=0&id=4ddb1d9c&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ddb1d9c"]])

export default __exports__